import { render } from "./PopupInfoContainer.vue?vue&type=template&id=ddbe1f00"
import script from "./PopupInfoContainer.vue?vue&type=script&lang=js"
export * from "./PopupInfoContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__